/**
  * @file
  * Attach behaviors for the checkout layout.
  */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Handle the donation checkbox.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.toggleCheckoutDonation = {

    attach: function () {

      let donationToggle = document.querySelector(
        '.form-item-donation-add-donation input[type="checkbox"]'
      );

      /**
       * Toggles the donation field display.
       *
       * @param {Object} e - The checkbox element.
       * @returns {undefined}.
       */
      function toggleDonation(e) {
        var element = $('#edit-donation-donation-details');
        if (e.target.checked) {
          element.attr('open', 'open');
        }
        else {
          element.removeAttr('open');
        }
      }

      donationToggle && donationToggle.addEventListener('change', toggleDonation, false);

    },

  };
})(document, Drupal, jQuery);
